import { useState, useEffect } from "react";

export function useContainerWidth(
  ref: React.RefObject<HTMLElement | null>,
  minWidth = 750,
) {
  const [isGreaterThan, setIsGreaterThan] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const element = ref.current;

    const checkSize = () => {
      if (element) {
        setIsGreaterThan(element.offsetWidth > minWidth);
      }
    };

    // Initial check
    checkSize();

    // Observe size changes
    const observer = new ResizeObserver(checkSize);
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [ref, minWidth]);

  return isGreaterThan;
}
